export const PHRASE_RESELECT = 'Reselect phrase';
export const PHRASE_SAVE_BTN_LABEL = 'Save to My Prompts';
export const PHRASE_SAVE_PROCESSING_LABEL = 'Saved...';